import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CTAButton } from './ui/CTAButton';
export function Offer() {
  return <AnimatedSection id="offer" className="py-24 px-6 max-w-4xl mx-auto text-center" data-id="element-109">
      <div className="bg-brand-cream border-4 border-brand-green/10 rounded-3xl px-8 py-6 md:px-12 md:py-8 shadow-2xl" data-id="element-110">
        <h2 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-111">
          Recupera tu movilidad
        </h2>
        <p className="text-xl mb-5 text-brand-gray/80" data-id="element-112">
          ...y dile adiós al dolor.
        </p>

        <div className="bg-white inline-block px-8 py-5 rounded-2xl shadow-inner mb-5 border border-brand-gray/10" data-id="element-113">
          <p className="text-sm font-medium text-brand-gray/60 uppercase tracking-wider mb-1" data-id="element-114">
            Precio especial de lanzamiento
          </p>
          <p className="text-xl text-brand-gray/40 line-through" data-id="element-115">$19 USD</p>
          <p className="text-5xl font-bold text-brand-terracotta" data-id="element-116">$6.36</p>
          <p className="text-xs mt-1 text-brand-green font-semibold uppercase tracking-wide" data-id="element-117">
            ¡Descuento aplicado! · Pago único
          </p>
        </div>

        <div data-id="element-118">
          <CTAButton className="text-xl py-5 px-10 w-full md:w-auto" data-id="element-119">
            ¡Sí, quiero moverme sin dolor!
          </CTAButton>
          <p className="mt-3 text-sm text-brand-gray/60" data-id="element-120">
            Descarga tu guía y empieza tu transformación hoy.
          </p>
        </div>
      </div>
    </AnimatedSection>;
}